import {useEffect} from 'react';
import {useConstCallback} from './useConstCallback';

export type UseDocumentKeyDownOptions = {
	disabled?: boolean;
};

export const USE_DOCUMENT_KEY_DOWN_DEFAULTS = {
	disabled: false,
};

export const useDocumentKeyDown = (
	cb: (event: KeyboardEvent) => boolean | void,
	{disabled}: UseDocumentKeyDownOptions = USE_DOCUMENT_KEY_DOWN_DEFAULTS,
) => {
	const handleKeyDown = useConstCallback((event: KeyboardEvent) => {
		if (cb(event) === false) {
			event.preventDefault();
			event.stopPropagation();
		}
	});

	useEffect(() => {
		if (disabled) return;

		document.addEventListener('keydown', handleKeyDown, {capture: true});

		return () => {
			document.removeEventListener('keydown', handleKeyDown, {capture: true});
		};
	}, [disabled]);
};

export default useDocumentKeyDown;
